import { token } from '@atlaskit/tokens';
import EllipsisOverflow from '@databases/field-value/common/EllipsisOverflow';
import { messages } from '@databases/intl/messages';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

export const DatabaseNameViewContainer = styled.div<{ isUnnamed: boolean }>`
  width: 100%;
  color: ${({ isUnnamed }) => (isUnnamed ? token('color.text.subtlest') : 'inherit')};
  padding: 4px;
  letter-spacing: 0;
`;

export interface DatabaseNameViewProps {
  name: string;
}
const DatabaseNameView: FunctionComponent<DatabaseNameViewProps> = ({ name }) => {
  const { formatMessage } = useIntl();

  return (
    <DatabaseNameViewContainer isUnnamed={!name}>
      <EllipsisOverflow position="bottom-start" testId="databaseName">
        {name || formatMessage(messages['unnamed-entities.untitled-database'])}
      </EllipsisOverflow>
    </DatabaseNameViewContainer>
  );
};

export default DatabaseNameView;
